// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { SubstitutionThresholdDetailsv2Fragment } from '../../SubstitutionThresholdSubform/graphql/SubstitutionThresholdSubform.generated';
import { gql } from '@apollo/client';
import { SubstitutionThresholdDetailsv2FragmentDoc } from '../../SubstitutionThresholdSubform/graphql/SubstitutionThresholdSubform.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetGratTrustThresholdsFromModalMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateEntityInput;
}>;


export type SetGratTrustThresholdsFromModalMutation = { __typename?: 'Mutation', updateEntity: (
    { __typename?: 'Entity' }
    & SubstitutionThresholdDetailsv2Fragment
  ) };

export const Operations = {
  Mutation: {
    SetGRATTrustThresholdsFromModal: 'SetGRATTrustThresholdsFromModal' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const SetGratTrustThresholdsFromModalDocument = gql`
    mutation SetGRATTrustThresholdsFromModal($input: AugmentedUpdateEntityInput!) {
  updateEntity(input: $input) {
    ...SubstitutionThresholdDetailsv2
  }
}
    ${SubstitutionThresholdDetailsv2FragmentDoc}`;
export type SetGratTrustThresholdsFromModalMutationFn = Apollo.MutationFunction<SetGratTrustThresholdsFromModalMutation, SetGratTrustThresholdsFromModalMutationVariables>;

/**
 * __useSetGratTrustThresholdsFromModalMutation__
 *
 * To run a mutation, you first call `useSetGratTrustThresholdsFromModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGratTrustThresholdsFromModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGratTrustThresholdsFromModalMutation, { data, loading, error }] = useSetGratTrustThresholdsFromModalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetGratTrustThresholdsFromModalMutation(baseOptions?: Apollo.MutationHookOptions<SetGratTrustThresholdsFromModalMutation, SetGratTrustThresholdsFromModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetGratTrustThresholdsFromModalMutation, SetGratTrustThresholdsFromModalMutationVariables>(SetGratTrustThresholdsFromModalDocument, options);
      }
export type SetGratTrustThresholdsFromModalMutationHookResult = ReturnType<typeof useSetGratTrustThresholdsFromModalMutation>;
export type SetGratTrustThresholdsFromModalMutationResult = Apollo.MutationResult<SetGratTrustThresholdsFromModalMutation>;
export type SetGratTrustThresholdsFromModalMutationOptions = Apollo.BaseMutationOptions<SetGratTrustThresholdsFromModalMutation, SetGratTrustThresholdsFromModalMutationVariables>;